import { filter, isEmpty, pipe, pick, prop, propOr } from 'ramda';
import { api, setter, fetchParams, fetchResponse } from '@/modules/helper';

export default {
  namespaced: true,

  state: {
    pagination: {
      skip: 0,
      limit: 10,
    },
    items: [],
  },

  mutations: {
    dynamicSet: setter,
  },

  getters: {
    items: prop('items'),
    activeItems: pipe(
      prop('items'),
      filter(({ is_deactivated }) => !is_deactivated),
    ),
    pagination: prop('pagination'),
  },

  actions: {
    create({ dispatch }, payload) {
      return api
        .post('scalpCondition', payload.data)
        .then(() => dispatch('fetch', { hardFetch: true }));
    },

    update({ dispatch }, payload) {
      return api
        .patch(`scalpCondition/${payload.id}`, payload.data)
        .then(() => dispatch('fetch', { hardFetch: true }));
    },

    exportData({ state }, payload) {
      const params = fetchParams(state, payload);

      return api.get('scalpCondition/export', {
        responseType: 'blob',
        params,
      });
    },

    fetch({ commit, state }, payload) {
      const hardFetch = propOr(false, 'hardFetch', payload);

      if (isEmpty(state.items) || hardFetch) {
        return api
          .get('scalpCondition', {
            params: fetchParams(state, payload),
          })
          .then(data => commit('dynamicSet', fetchResponse(data)));
      }
    },

    remove({ dispatch }, id) {
      return api
        .delete(`scalpCondition/${id}`)
        .then(() => dispatch('fetch', { hardFetch: true }));
    },

    reactivate({ dispatch }, id) {
      return api
        .patch(`scalpCondition/reactivate/${id}`)
        .then(() => dispatch('fetch', { hardFetch: true }));
    },
  },
};
